import { MAX_PRISM_LENGTH, rangeValues, signed, type CatalogRanges, type EyeRx } from '@glasses/shared'

const num = (v: string): number | null => (v === '' ? null : Number(v))
const text = (v: string): string | null => (v === '' ? null : v)
const shown = (v: number | string | null): string => (v === null ? '' : String(v))

/** One eye's row of the prescription table; ids `{eye}-sphere` ... `{eye}-base`. */
export function RxRow({
  eye,
  label,
  rx,
  ranges,
  onChange,
}: {
  /** "od" or "os" - prefixes the element ids. */
  eye: 'od' | 'os'
  label: string
  rx: EyeRx
  ranges: CatalogRanges
  onChange: (rx: EyeRx) => void
}) {
  const set = (patch: Partial<EyeRx>) => onChange({ ...rx, ...patch })
  return (
    <tr>
      <th scope="row">{label}</th>
      <td>
        <select id={`${eye}-sphere`} aria-label={`${label} sphere`} value={shown(rx.sphere)} onChange={(e) => set({ sphere: num(e.target.value) })}>
          <option value="">–</option>
          {rangeValues(ranges.sphere).map((v) => (
            <option key={v} value={String(v)}>
              {signed(v)}
            </option>
          ))}
        </select>
      </td>
      <td>
        <select id={`${eye}-cylinder`} aria-label={`${label} cylinder`} value={shown(rx.cylinder)} onChange={(e) => set({ cylinder: num(e.target.value) })}>
          <option value="">–</option>
          {rangeValues(ranges.cylinder).map((v) => (
            <option key={v} value={String(v)}>
              {signed(v)}
            </option>
          ))}
        </select>
      </td>
      <td>
        <select id={`${eye}-axis`} aria-label={`${label} axis`} value={shown(rx.axis)} onChange={(e) => set({ axis: num(e.target.value) })}>
          <option value="">–</option>
          {rangeValues(ranges.axis).map((a) => (
            <option key={a} value={String(a)}>
              {a}
            </option>
          ))}
        </select>
      </td>
      <td>
        <input id={`${eye}-prism`} aria-label={`${label} prism`} size={5} maxLength={MAX_PRISM_LENGTH} value={shown(rx.prism)} onChange={(e) => set({ prism: text(e.target.value) })} />
      </td>
      <td>
        <input id={`${eye}-base`} aria-label={`${label} base`} size={5} maxLength={MAX_PRISM_LENGTH} value={shown(rx.base)} onChange={(e) => set({ base: text(e.target.value) })} />
      </td>
    </tr>
  )
}
